import type { SelectedSoundtrackId } from "../config/soundtrack-config";

export const audioCueIdentifiers = [
  "pickup",
  "level",
  "crunch",
  "win",
  "defeat",
  "respawn",
  "results",
  "turbo",
] as const;

export type AudioCueIdentifier = (typeof audioCueIdentifiers)[number];

export type AudioAutoplayState = "blocked" | "pending" | "permitted";

export type AudioPlaybackResult = "blocked" | "played" | "unavailable";

export interface SoundtrackCacheSnapshot {
  readonly activeLoopCount: number;
  readonly cachedTrackIds: readonly SelectedSoundtrackId[];
  readonly configuredDecodedTrackLimit: number;
  readonly decodedTrackCount: number;
  readonly pendingDecodeCount: number;
}

export interface AudioBoundary {
  destroy(): void;
  getAssetUrl(trackId: SelectedSoundtrackId): string;
  getSoundtrackCacheSnapshot(): SoundtrackCacheSnapshot;
  playCue(identifier: AudioCueIdentifier): Promise<AudioPlaybackResult>;
  startMusic(trackId: SelectedSoundtrackId): Promise<AudioPlaybackResult>;
  stopMusic(): void;
  suspend(): Promise<void>;
  unlock(): Promise<boolean>;
}
